module.exports = __webpack_public_path__ + "media/images/emblems/Basadingen-Schlattingen-Blazono-866be8c26348e33a1d0ced358c29cd9a.png";